import { render, staticRenderFns } from "./ConfigUsuarioGrupos.vue?vue&type=template&id=5c6a5aea&scoped=true&lang=pug&"
import script from "./ConfigUsuarioGrupos.vue?vue&type=script&lang=js&"
export * from "./ConfigUsuarioGrupos.vue?vue&type=script&lang=js&"
import style0 from "./ConfigUsuarioGrupos.vue?vue&type=style&index=0&id=5c6a5aea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6a5aea",
  null
  
)

export default component.exports